(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('PaymentRemittancesListController', PaymentRemittancesListController)

    /** @ngInject */
    function PaymentRemittancesListController(sweetAlert, HelperService, PaymentSlipRemittanceService) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedSearchField && vm.searchText)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedSearchField = null;
            vm.searchText = null;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getPaymentRemittances(start, number, tableState);
        }

        vm.deletePaymentRemittance = paymentRemittance => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Essa ação não poderá ser desfeita',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.loading-holder');

                    PaymentSlipRemittanceService
                        .delete(paymentRemittance.Id)
                        .then(
                            () => {
                                HelperService.successCallback('delete');
                                HelperService.stopLoading('.loading-holder');

                                vm.tableCallServer();
                            }, error => {
                                HelperService.errorCallback(error);
                                HelperService.stopLoading('.loading-holder');
                            })
                }
            })
        }

        init();

        function getPaymentRemittances(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            PaymentSlipRemittanceService
                .getByParameters(parameters)
                .then(success => {
                    vm.paymentRemittances = success.Remittances;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.paymentRemittances = null;
                    vm.isLoading = false;
                    HelperService.errorCallback(error);
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'RegistrationDate',
                OrderDescending: true
            }

            if (vm.selectedSearchField && vm.searchText)
                isTableSearch = true;

            if (tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Value;
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function init() {
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;

            vm.searchFields = [{
                Value: 'ExternalCode',
                Description: 'Código Externo'
            }, {
                Value: 'Description',
                Description: 'Descrição'
            }];
        }
    }
}());